<template>
  <el-select
    :value="ownerId"
    filterable
    remote
    :size="size"
    placeholder="Поиск по клиентам"
    style="width: 100%"
    :loading="loading && !clients.length"
    :remote-method="remoteMethod"
    @change="change"
  >
    <el-option
      v-for="client in clients"
      :key="client.id_account"
      :value="client.id_account"
      :label="client.client_name"
    >
      <span style="float: left">{{ client.client_name }}</span>
      <span style="float: right; color: #8492a6; font-size: 13px; margin-left: 10px">{{ client.login }}</span>
    </el-option>
    <el-option
      v-if="total && total - clients.length"
      :value="0"
      disabled
      style="align-items: center; text-align: center"
    >
      <el-button :loading="loading && !queryLoading" type="text" style="width: 100%" size="mini" @click="nextPage">
        {{ loading && !queryLoading ? "Загрузка" : "Показать ещe" }}
      </el-button>
    </el-option>
  </el-select>
</template>

<script>
import { ApiService } from "@/api";

export default {
  name: "SelectClient",
  model: {
    prop: "owner-id",
    event: "change",
  },
  props: {
    ownerId: {
      type: Number,
      default: null,
    },
    size: {
      type: String,
      default: "small",
    },
    withCrossShared: {
      type: Boolean,
      default: false,
    },
    cameraId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      page: 1,
      query: "",
      total: 0,
      queryLoading: false,
      loading: false,
      clients: [],
    };
  },
  mounted() {
    if (this.ownerId) {
      this.loading = true;
      ApiService.client.get(this.ownerId).then((owner) => {
        this.clients = [owner];
      });
    }
    this.pullClients(true);
  },
  watch: {
    ownerId() {
      if (this.ownerId && !this.clients.find((c) => c.id_account === this.ownerId)) {
        this.loading = true;
        ApiService.client
          .get(this.ownerId)
          .then((owner) => {
            this.clients = [owner, ...this.clients].filter(this.findDuplicates);
          })
          .finally(() => {
            this.loading = false;
          });
      }
    }
  },
  methods: {
    clearData() {
      this.page = 1;
      this.total = 0;
      this.clients = [];
    },
    remoteMethod(query) {
      this.queryLoading = true;
      this.query = encodeURI(query);
      this.clearData();
      this.pullClients().finally(() => {
        this.queryLoading = false;
      });
    },
    nextPage() {
      this.page = this.page + 1;
      this.pullClients(true);
    },
    findDuplicates(client, index, array) {
      return !array.slice(index + 1).find((c) => c.id_account === client.id_account);
    },
    pullClients(update = false) {
      const { page, query: search } = this;

      let method;

      if (this.withCrossShared) {
        method = ApiService.client.getListForShare.bind(this);
      } else {
        method = ApiService.client.getList.bind(this);
      }

      this.loading = true;
      return method({ search, page, count: 10, ...(this.withCrossShared && this.cameraId && { id_camera: this.cameraId }) })
        .then(({ data: clients, total }) => {
          this.total = total;
          this.clients = (update ? [...this.clients, ...clients] : clients).filter(this.findDuplicates);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    change(id) {
      const selectedClient = this.clients.find((c) => c.id_account === id);
      this.$emit("change", selectedClient);
    },
  },
};
</script>
